import { render, staticRenderFns } from "./UserDebtInfo.vue?vue&type=template&id=35c619f1&"
import script from "./UserDebtInfo.vue?vue&type=script&lang=js&"
export * from "./UserDebtInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports